import "@fullcalendar/core/vdom";
import { Calendar } from "@fullcalendar/core";
import itLocale from '@fullcalendar/core/locales/it';
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import dayjs from "dayjs";
import moment from "moment";
//import tippy, { roundArrow } from "tippy.js";

window.$ = window.jQuery = require('jquery');

let tippyInstance = '';

(function ($) {

    if ($(".full-calendars.course-calendar").length) {

        $(".full-calendars.course-calendar").each(function () {
            let dom_element = $(this)[0];
            let eventSources = $(this).data('event-sources');

            let selected_date = moment();

            let calendar = new Calendar(dom_element, {
                initialDate: selected_date.format('YYYY-MM-DD'),
                headerToolbar: {
                    left:   'title',
                    center: '',
                    right:  'today prev,next'
                },
                firstDay: 1,
                slotEventOverlap: false,	// non fa sovrapporre gli eventi
                //dayHeaderFormat : { weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true },
                slotLabelFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short'
                },
                selectable: false,
                selectMirror: true,
                displayEventTime: false,
                initialView: 'dayGridMonth',
                plugins: [
                    interactionPlugin,
                    dayGridPlugin,
                ],
                editable: false,
                dayMaxEvents: true,

                eventClick: function(info) {
                    //console.log('Event ID: ' + info.event.id);
                    //console.log('Event TYPE: ', info.event.extendedProps.type);
                    //console.log('Event: ' + info.event.title);
                    //console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
                    //console.log('View: ' + info.view.type);

                    info.jsEvent.preventDefault(); // don't let the browser navigate

                    if (info.event.url) {
                        window.open(info.event.url, "_self");
                    }
                },
                eventSources: {
                    url: eventSources,
                    method: 'GET',
                    failure: function() {
                        window.dispatchEvent(
                            new CustomEvent('livewire-alert', {'detail': {
                                'type': 'danger',
                                'title': '',
                                'message': 'Errore nel caricamento degli appuntamenti'
                            } })
                        );
                    },
                    'textColor': '#333',
                }
            });

            calendar.render();

        });
    }
})(window.$);
